$(document).ready(function () {
    var articleUrl = window.location.pathname.split("/").pop();

    if ($("#mi-blog-related-articles-list").length == 0) {
        showResults(articleUrl);
    }

});

function showResults(articleUrl) {
    var queryString = "?articleUrl=" + articleUrl + "&selectedItemId=" + $('#mi-corpo-blog-selectedItemId').val();
    var requestManager = new AsyncRequestManager();
    requestManager.renderAsyncRequest('/blogrelatedarticles/searchrelatedarticles', queryString, '[data-widget="elcablogrelatedarticles"]', true);
}	